import { NgModule, ModuleWithProviders, Injectable } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
// import { SignaturePadModule } from 'angular2-signaturepad';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatChipsModule } from '@angular/material/chips';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatStepperModule } from '@angular/material/stepper';
import { MatRadioModule } from '@angular/material/radio';
import { MatDividerModule } from '@angular/material/divider';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSliderModule } from '@angular/material/slider';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatOptionModule } from '@angular/material/core';

import { OverlayModule } from '@angular/cdk/overlay';
import { ZipCodeComponent } from './zip-code/zip-code.component';
import { LocationTypesComponent } from './location-types/location-types.component';

import { LoaderComponent } from '../layouts/loader/loader.component';
import { BackComponent } from './back/back.component';
import { SelectLocationComponent } from './select-location/select-location.component';
import { SelectDepartmentComponent } from './select-department/select-department.component';
import { DataTableComponent } from './data-table/data-table.component';
import { NgxMaskDirective, provideNgxMask  } from 'ngx-mask'
import {PhoneNumberPipe} from '../pipes/phoneNumber';
import {ShortNumberPipe} from '../pipes/shortNumber';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { SimpleDialogComponent } from './simple-dialog/simple-dialog.component';
import { NoDataComponent } from './no-data/no-data.component';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';
import { BlockUnblockComponent } from './blockUnblock/blockUnblock.component';
// import { CustomFormsModule } from 'ng2-validation';
import { StripeCardComponent } from './stripe-card/stripe-card.component';
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, NativeDateAdapter} from '@angular/material/core';
import { ClaimModalComponent } from './claim-modal/claim-modal.component';
// import { SignaturePadComponent } from './signature-pad/signature-pad.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxPlaidLinkModule } from "ngx-plaid-link";
import { Safe } from '../pipes/safeHTML';
import { VimeoUrlPipe } from '../pipes/vimeo-url.pipe';
import { ProfileDialogComponent } from './profile-dialog/profile-dialog.component';
import { SocketsService } from '../services/shared/socket.service';
import { InputComponent } from './input/input.component';
import { CarouselComponent } from './carousel/carousel.component';
import { SelectComponent } from './select/select.component';
import { DecimaNumberDirective } from '../directives/decimal-number.directive';
import { NotificationIconComponent } from '../pages/misc/notification-icon/notification-icon.component';
import { ContractDetailsComponent } from '../pages/contract/contract-details/contract-details.component';
import { ContractDialogComponent } from '../pages/contract/contract-modal/contract-modal.component';
import { NumbersOnlyDirective } from '../directives/numbers-only.directive';
import { NotificationsComponent } from '../pages/misc/notifications/notifications.component';
import { TooltipDirective } from '../directives/tooltip.directive';
import { DialogContentExampleDialog } from '../pages/trainings/video-tutorials/video-tutorials.component';
import { underscorelessPipe } from '../pipes/underscoreless';
import { CanonicalService } from '../services/canonical.service';
import { UpgradePlanComponent } from '../pages/upgrade-plan/upgrade-plan.component';
import { ComparePlansComponent } from '../pages/compare-plans/compare-plans.component';
import { GoogleApiComponent } from './google-api/google-api.component';
import { AccountReceiveableDetailsComponent } from '../pages/account-receiveable/account-receiveable-details/account-receiveable-details.component';
import { ModalsComponent } from '../pages/leads/modals/modals.component';
import { ColorPickerModule } from '@iplab/ngx-color-picker';
import { AddCardComponent } from './add-card/add-card.component';
import { ModalComponent } from '../pages/business-referral/modal/modal.component';
import { SignatureNewComponent } from './signature-new/signature-new.component';
import { StripeComponent } from './stripe/stripe.component';
import { BgProposalProgressComponent } from './bg-proposal-progress/bg-proposal-progress.component';
import { TrimDirective } from '../directives/trim.directive';
import { NoLeadingSpaceDirective } from '../directives/no-leading-space.directive';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ImageCropperComponent  } from 'ngx-image-cropper';
import { PaymentOptionsComponent } from './payment-options/payment-options.component';
import { TerminalCheckoutPanelComponent } from './terminal-checkout-panel/terminal-checkout-panel.component';
import { CustomerPreviewComponent } from './customer-preview/customer-preview.component';
import { RadialSelectorComponent } from './radial-selector/radial-selector.component';
import { QuestionnaireDialogComponent } from './questionnaire-dialog/questionnaire-dialog.component';
import { UploadIdentityDialogComponent } from './upload-identity-dialog/upload-identity-dialog.component';
export const MY_FORMATS = {
  parse: {
    dateInput: { month: 'short', year: 'numeric', day: 'numeric' }
  },
  display: {
    dateInput: 'input',
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  }
};
@Injectable({
  providedIn: 'root'
})
export class CustomDateAdapter extends NativeDateAdapter {
  format(date: Date, displayFormat: Object): string {
    if (displayFormat === 'input') {
      const day = ("0" + date.getDate()).slice(-2);
      const month = ("0" + (date.getMonth() + 1)).slice(-2);
      const year = date.getFullYear();
      // Return the format as per your requirement
      return `${month}/${day}/${year}`;
    } else {
      return date.toDateString();
    }
  }
}
@NgModule({
    declarations: [
        InputComponent,
        CarouselComponent,
        ZipCodeComponent,
        LoaderComponent,
        LocationTypesComponent,
        SelectLocationComponent,
        SelectDepartmentComponent,
        BackComponent,
        DataTableComponent,
        PhoneNumberPipe,
        VimeoUrlPipe,
        underscorelessPipe,
        FileUploadComponent,
        SimpleDialogComponent,
        ContractDialogComponent,
        DialogContentExampleDialog,
        NoDataComponent,
        ShortNumberPipe,
        Safe,
        BlockUnblockComponent,
        StripeCardComponent,
        ClaimModalComponent,
        // SignaturePadComponent,
        ProfileDialogComponent,
        CarouselComponent,
        DecimaNumberDirective,
        NumbersOnlyDirective,
        TooltipDirective,
        NotificationIconComponent,
        SelectComponent,
        ContractDetailsComponent,
        NotificationsComponent,
        UpgradePlanComponent,
        ComparePlansComponent,
        GoogleApiComponent,
        AccountReceiveableDetailsComponent,
        ModalsComponent,
        AddCardComponent,
        ModalComponent,
        SignatureNewComponent,
        StripeComponent,
        BgProposalProgressComponent,
        TrimDirective,
        NoLeadingSpaceDirective,
        PaymentOptionsComponent,
        TerminalCheckoutPanelComponent,
        CustomerPreviewComponent,
        RadialSelectorComponent,
        UploadIdentityDialogComponent,
        QuestionnaireDialogComponent,
        UploadIdentityDialogComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        MatToolbarModule,
        MatIconModule,
        MatSidenavModule,
        MatListModule,
        MatButtonModule,
        MatExpansionModule,
        OverlayModule,
        MatMenuModule,
        MatSlideToggleModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatCheckboxModule,
        MatSnackBarModule,
        MatDialogModule,
        MatTableModule,
        MatPaginatorModule,
        MatSelectModule,
        MatAutocompleteModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        MatRippleModule,
        MatDatepickerModule,
        MatNativeDateModule,
        NgxTrimDirectiveModule,
        NgxMaskDirective,
        MatChipsModule,
        MatTooltipModule,
        MatBottomSheetModule,
        MatStepperModule,
        // CustomFormsModule,
        MatRadioModule,
        MatDividerModule,
        MatTabsModule,
        // SignaturePadModule,
        NgbModule,
        NgxPlaidLinkModule,
        CarouselModule,
        MatSliderModule,
        ColorPickerModule,
        MatAutocompleteTrigger,
        ImageCropperComponent,
    ],
    exports: [
        ContractDetailsComponent,
        SelectComponent,
        NotificationIconComponent,
        NotificationsComponent,
        RouterModule,
        ReactiveFormsModule,
        FormsModule,
        ReactiveFormsModule,
        MatToolbarModule,
        MatIconModule,
        MatSidenavModule,
        MatListModule,
        MatButtonModule,
        MatExpansionModule,
        OverlayModule,
        MatMenuModule,
        MatSlideToggleModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatCheckboxModule,
        MatSnackBarModule,
        MatDialogModule,
        MatTableModule,
        MatPaginatorModule,
        MatSelectModule,
        MatAutocompleteModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        MatRippleModule,
        ZipCodeComponent,
        LoaderComponent,
        LocationTypesComponent,
        BackComponent,
        SelectLocationComponent,
        SelectDepartmentComponent,
        DataTableComponent,
        FileUploadComponent,
        MatDatepickerModule,
        MatNativeDateModule,
        PhoneNumberPipe,
        VimeoUrlPipe,
        underscorelessPipe,
        ShortNumberPipe,
        Safe,
        SimpleDialogComponent,
        ContractDialogComponent,
        ClaimModalComponent,
        NoDataComponent,
        NgxTrimDirectiveModule,
        BlockUnblockComponent,
        MatChipsModule,
        MatTooltipModule,
        MatBottomSheetModule,
        MatStepperModule,
        // CustomFormsModule,
        MatRadioModule,
        MatDividerModule,
        StripeCardComponent,
        MatTabsModule,
        // SignaturePadModule,
        // SignaturePadComponent,
        InputComponent,
        CarouselComponent,
        DecimaNumberDirective,
        NumbersOnlyDirective,
        TooltipDirective,
        CarouselModule,
        UpgradePlanComponent,
        ComparePlansComponent,
        GoogleApiComponent,
        AccountReceiveableDetailsComponent,
        ModalsComponent,
        ColorPickerModule,
        ModalComponent,
        SignatureNewComponent,
        StripeComponent,
        BgProposalProgressComponent,
        TrimDirective,
        NoLeadingSpaceDirective,
        NgxMaskDirective,
        PaymentOptionsComponent,
        TerminalCheckoutPanelComponent,
        CustomerPreviewComponent,
        RadialSelectorComponent,
        UploadIdentityDialogComponent,
        QuestionnaireDialogComponent,
        UploadIdentityDialogComponent,
    ],
    providers: [
        DecimaNumberDirective,
        NumbersOnlyDirective,
        TooltipDirective,
        CanonicalService,
        TrimDirective,
        NoLeadingSpaceDirective,
        provideNgxMask(),
        {
            provide: DateAdapter,
            useClass: CustomDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ]
})
// export class SharedModule { }
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule
    };
  }
}


